import path from 'path'

export default {
  defaults: {
    modal: {
      __typename: 'ClientModal',
      id: null,
      data: null
    }
  },
  resolvers: {
    Mutation: {
      showModal: (_, { id, data }, { cache }) => {
        cache.writeData({
          data: {
            modal: {
              __typename: 'ClientModal',
              id,
              data: JSON.stringify(data)
            }
          }
        })

        return null
      }
    },
    File: {
      extension: (file) => {
        return path.extname(file.image).replace('.', '')
      }
    }
  }
}
